// document.addEventListener('DOMContentLoaded', function () {
//     let lightGalleries = document.querySelectorAll('.lightgallery-carousel');
//     if (lightGalleries.length > 0) {
//         for (const gallery of lightGalleries) {
//             let thisGallery = lightGallery(gallery, {
//                 counter: true,
//                 download: false,
//                 mode: 'lg-slide',
//                 cssEasing: 'cubic-bezier(.45, .06, .15, 1)',
//                 subHtmlSelectorRelative: true,
//                 getCaptionFromTitleOrAlt: gallery.dataset.class == "hideCaption" ? false : true
//             });

//             if (document.querySelectorAll(gallery.dataset.trigger).length > 0) {
//                 document.querySelector(gallery.dataset.trigger).addEventListener('click', (e) => {
//                     e.preventDefault();
//                     gallery.firstElementChild.click();
//                 });
//             }
//         }
//     }

//     let lightGalleriesSimple = document.querySelectorAll('.lightgallery');
//     if (lightGalleriesSimple.length > 0) {
//         for (const gallery of lightGalleriesSimple) {
//             let thisGallery = lightGallery(gallery, {
//                 plugins: [lgVideo, lgThumbnail, lgZoom],
//                 counter: true,
//                 download: false,
//                 mode: 'lg-slide',
//                 cssEasing: 'cubic-bezier(.45, .06, .15, 1)',
//                 subHtmlSelectorRelative: true,
//                 preload: 1,
//                 thumbnail: gallery.dataset.thumbnail === "show",
//                 getCaptionFromTitleOrAlt: gallery.dataset.class !== "hideCaption",
//                 youTubePlayerParams: {
//                     modestbranding: 1,
//                     showinfo: 0,
//                     controls: 1,
//                     rel: 0
//                 }
//             });

//             if (document.querySelectorAll(gallery.dataset.trigger).length > 0) {
//                 let allImagesBtn = document.querySelectorAll(gallery.dataset.trigger);
//                 for (const imageBtn of allImagesBtn) {
//                     imageBtn.addEventListener('click', (e) => {
//                         e.preventDefault();
//                         if (imageBtn.dataset.imgcount) {
//                             gallery.getElementsByTagName('a')[imageBtn.dataset.imgcount].click();
//                         } else {
//                             gallery.firstElementChild.click();
//                         }
//                     });
//                 }
//             }
//         }
//     }
// });